import { Box, Container, Link, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import PaypalSuccessPayments from "./success-payments/Paypal";
import StripeSuccessPayments from "./success-payments/Stripe";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function PaymentSuccessful(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const searchParams = useQuery();
  const methods = searchParams.get("methods");
  const direct_confirm = searchParams.get("direct_confirm");
  const session_slug = searchParams.get("session_slug");
  const type = searchParams.get("payment_type") ?? "direct_payment";

  if (methods === "stripe") {
    return (
      <StripeSuccessPayments
        session_slug={session_slug}
        direct_confirm={direct_confirm}
        type={type}
      />
    );
  }

  if (methods === "paypal") {
    return (
      <PaypalSuccessPayments
        session_slug={session_slug}
        direct_confirm={direct_confirm}
      />
    );
  }

  return (
    <div
      style={{
        height: "calc(100vh - 120px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Container maxWidth={"lg"}>
        <div>
          <Box mb={3}>
            <Typography variant={"h5"}>
              {t("booking.payment.process_successful")}
            </Typography>
            <Typography variant={"h6"}>
              {t("booking.payment.process_successful.description")}
            </Typography>
          </Box>

          <Link onClick={() => navigate(`/`)} sx={{ cursor: "pointer" }}>
            {t("booking.button.home")}
          </Link>
        </div>
      </Container>
    </div>
  );
}

export default PaymentSuccessful;
